export const normalizeHttpUrl = (raw: string | null | undefined): string | null => {
  const link = (raw ?? '').trim();
  if (!link || /\s/.test(link)) return null;

  try {
    const url = new URL(link);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
  } catch {
    return null;
  }
};

export const isValidHttpUrl = (raw: string | null | undefined): boolean => normalizeHttpUrl(raw) !== null;
